import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';
import { BLOCKS } from '@contentful/rich-text-types';

import { FAQCategoryCards } from '../../../Custom/Card-Sections';
import FAQSections from '../../../Custom/FAQ/FAQSections';
import BreadCrumbs from '../../../Custom/BreadCrumbs';
import RichText from '../../../Core/RichText';

import { StyledContainer, Wrapper, Title, StyledFAQSearch } from './styles';

const FAQScreen = ({ data }) => {
  if (!data) return null;
  const { elements, sectionContainerHeading } = data;
  const intl = useIntl();

  let featuredData = null;
  let cardData = null;
  elements.forEach(section => {
    if (section.component === 'FAQ-category-filter-block') {
      cardData = {
        cards: section.filterItems,
        heading: section.heading,
        headingAlignment: 'center-aligned',
      };
    } else {
      featuredData = section;
    }
  });

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Title>{children}</Title>,
      [BLOCKS.HEADING_2]: (_, children) => <Title>{children}</Title>,
    },
  };

  return (
    <>
      <BreadCrumbs
        className="end-chevron"
        crumbs={[
          {
            label: `${intl.formatMessage({ id: 'learningHub' })}`,
            slug: '/learning-hub',
            active: true,
          },
        ]}
      />
      <StyledContainer>
        <Wrapper>
          <RichText document={sectionContainerHeading} options={header} />
        </Wrapper>
        <StyledFAQSearch
          type="is-open"
          placeholder={`${intl.formatMessage({ id: 'FAQSearchPlaceholder' })}`}
          predictiveSearch
          predictiveSearchClass="centered-results"
        />
      </StyledContainer>
      <FAQSections data={featuredData} />
      <FAQCategoryCards data={cardData} />
    </>
  );
};

FAQScreen.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default FAQScreen;
